import { BookingSpace } from '../../domain/models/space.model';
import { IApiBookingSpace, } from "../interfaces/booking-space.interface";

export class BookingSpaceMapper {
  static fromJSON(apiSpace: IApiBookingSpace): BookingSpace {
    return new BookingSpace(
      apiSpace._id,
      apiSpace.organization_id,
      apiSpace.number,
      apiSpace.name,
      apiSpace.capacity,
      apiSpace.status,
      apiSpace.rate_ids,
      apiSpace.zone_id,
      apiSpace.description
    );
  }

  static toJSON(space: BookingSpace): IApiBookingSpace {
    return {
      _id: space?.id,
      organization_id: space.organizationId,
      zone_id: space.zoneId,
      number: space.number,
      name: space.name,
      description: space.description,
      capacity: space.capacity,
      status: space.status,
      rate_ids: space.rateIds
    };
  }
}
